import flatpickr from '../vendor/flatpickr';

const datePicker = () => {
  if (
    typeof document.querySelector('.flatpickr') != 'undefined' &&
    document.querySelector('.flatpickr') != null
  ) {
    document.querySelectorAll('.flatpickr input').forEach(el => {
      const mode = el.closest('.flatpickr')?.dataset?.mode;

      flatpickr(el, {
        enableTime: false,
        dateFormat: 'Y-m-d',
        minDate: 'today',
        mode: mode ? mode : 'single',
        disable: [
          function (date) {
            // Disable saturday & sunday
            return date.getDay() === 0 || date.getDay() === 6;
          },
        ],
        locale: {
          firstDayOfWeek: 1, // start week on Monday
        },
        onChange: function (selectedDates, dateStr, instance) {
          if (selectedDates.length > 4) {
            instance.clear();
          }
        },
      });
    });
  }
};

export default datePicker;
